var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"modal-w-100 modal--makes"},[_c('h2',{staticClass:"visually-hidden"},[_vm._v("Выберите марку автомобиля")]),_vm._v(" "),_c('div',{staticClass:"modal__wrap grid grid__container"},[_c('div',{staticClass:"grid__col-12"},[_c('makes'),_vm._v(" "),_c('br')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }